<template>
    <div class="system-function">
        <div @click.stop="changImageOpen(info.id)" class="select-bar" :class="{'select-bar-top': !open}">
            <span>{{ info.name }}</span>
            <img :class="{'turn-down': open}" :src="require('@/assets/images/project-detail/select-system.png')" alt="">
        </div>
        <!--   大图实体  -->
        <!-- <transition name="fade"> -->
        <div v-show="open" class="img-box">

            <img class="image" v-lazy v-show="info.image" v-lazy="info.image" alt=""/>
            <video loop preload="auto" ref="videoEl" class="video-view" v-if="info.video" :src="info.video" :playsinline="true" :controls="false"/>
            <img class="cover-image" @click="handleCoverClick" v-if="clickCover" v-lazy="info.cover" alt=""/>
            <img class="cover-image-play" @click="handleCoverClick" v-if="clickCover" v-lazy="info.coverIcon" alt=""/>
        </div>
        <!-- </transition> -->
    </div>
</template>

<script>


export default {
    name: "custom-system",

    props: {
        /**
         * // 大标题 title: String
         * // 图片 image: String
         * // 首个封面图 cover: String
         * // 视频 video: String
         */
        info: {
            type: Object,
            default: () => ({})
        },

        // 大图是否打开
        open: Boolean,

    },
    data() {
        return {
            // 需要点击播放
            clickCover: false,
        }
    },
    created() {
        this.hasClickCover();
    },
    methods: {
        /**
         * 处理是否需要点击播放
         */
        hasClickCover() {
            this.clickCover = !!this.info?.cover;
        },
        /**
         * 控制大图打开
         * @param { number } id 标识
         */
        changImageOpen(id) {
            this.$store.commit({type: 'projectDetailCustom/CHANGE_SYSTEM_FUNC_VISIBLE', id})
            this.$store.commit({type: 'projectDetailCustomBeijingOne/CHANGE_SYSTEM_FUNC_VISIBLE', id})
            this.$nextTick(() => {
                this?.info?.video && this.open && this.handleCoverClick();
            })

        },
        /**
         * 隐藏封面播放视频
         */
        handleCoverClick() {
            // 隐藏封面
            this.clickCover = false;
            // 视频播放
            this.$refs.videoEl.play();
        }
    },
}
</script>

<style scoped lang="scss">
.system-function {
    color: #FFFFFF;
    // margin-bottom: 12px;


    .select-bar {
        background: $greenGradient;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100px;
        border-radius: 10px 10px 0 0;
        padding: 0 34px;
        transition: all 0.3s;


        img {
            width: 48px;
            height: 48px;
            transform: rotate(0);
            transition: all 0.3s;
        }

        .turn-down {
            transform: rotate(180deg);
        }
    }

    .select-bar-top {
        border-radius: 10px;
    }

    .img-box {
        transition: all 0.3s;
        overflow: hidden;
        padding-bottom: 28px;
        position: relative;
        min-height: 850px;

        .skeleton {
            margin: 40px 0;
            padding: 0;
            position: absolute;
            width: 654px;
            height: auto;
            background: #FFFFFF;
        }

        .image {
            border-radius: 0 0 10px 10px;
            overflow: hidden;
        }

        .video-view {
            width: 100%;
            height: auto;
            border-radius: 0 0 10px 10px;
        }

        .cover-image {
            width: 100%;
            height: auto;
            position: absolute;
            left: 0;
            top: 0;
        }

        .cover-image-play {
            width: 80px;
            height: 80px;
            position: absolute;
            left: calc(50% - 40px);
            top: calc(50% - 40px);
        }
    }


}

</style>
